import { GetterTree } from 'vuex';
import { CommentView, CommentsState } from './models';
import { RootState } from '@/store';

export enum Getters {
    COMMENTS = 'GET_COMMENTS',
    LOADED = 'LOADED',
    FETCHING = 'FETCHING',
  }

export const getters: GetterTree<CommentsState, RootState> = {
  [Getters.COMMENTS]({ comments }): CommentView[] {
    return comments;
  },
};
